import React from 'react';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';
import { useAppSelector } from 'store/store.hook';
import { OnboardingContext, OnboardingContextProvider } from './onboarding.context';
import { OnboardingDialogs } from './onboarding.dialog';

export const Onboarding = () => {
  const { isAdmin } = useAppSelector(selectCurrentUserInfo);

  if (!isAdmin) {
    return null;
  }

  return (
    <OnboardingContextProvider>
      <OnboardingContext.Consumer>
        {({ visible }) => (visible ? <OnboardingDialogs /> : null)}
      </OnboardingContext.Consumer>
    </OnboardingContextProvider>
  );
};
